import { padTime } from './padTime'

export function getTimeValues(
    value: Date,
    format: '12' | '24',
    amLabel: string,
    pmLabel: string
) {
    if (!(value instanceof Date)) {
        return { hours: '', minutes: '', seconds: '', amPm: '' }
    }

    let _hours = value?.getHours() || 0

    const isPm = _hours >= 12
    if (format === '12') {
        _hours %= 12
        if (_hours === 0) {
            _hours += 12
        }
    }

    let _minutes = value?.getMinutes() || 0
    let _seconds = value?.getSeconds() || 0

    return {
        hours: padTime(_hours.toString()),
        minutes: padTime(_minutes.toString()),
        seconds: padTime(_seconds.toString()),
        amPm: isPm ? pmLabel : amLabel,
    }
}
